import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BulkActionProcessingResults } from '@app/shared/components/bulk-actions/models/bulk-action-dialog-result';
import { BootstrapSemanticVariation } from '@app/utils/bootstrap';

@Component({
  selector: 'portal-bulk-action-dialog-footer',
  templateUrl: './bulk-action-dialog-footer.component.html',
  styles: [],
  standalone: false,
})
export class BulkActionDialogFooterComponent implements OnInit {
  @Input()
  actionLabel!: string;

  @Input()
  disabled!: boolean;

  @Input()
  invalid!: boolean;

  @Input()
  pending!: boolean;

  @Input()
  result!: BulkActionProcessingResults | null;

  @Input()
  variant!: BootstrapSemanticVariation;

  @Output()
  close = new EventEmitter<void>();

  @Output()
  dismiss = new EventEmitter<void>();

  @Output()
  submit = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {}
}
